export enum messagetype {
    General = 1,
    Payment = 2
}